import MainService from './main'
import CardService from './card'

export default {
  MainService,
  CardService
}

